import Vue from "vue";
import VueApollo from "vue-apollo";
import {
  createApolloClient,  
} from "vue-cli-plugin-apollo/graphql-client";
import { setContext } from 'apollo-link-context';
import AuthService from './services/auth-service';

// Install the vue plugin
Vue.use(VueApollo);

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  //httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  //wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || "ws://localhost:4000/graphql",
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,  

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: myLink

  // Override default cache
  // cache: myCache

  // Override the way the Authorization header is set
  // getAuth: (tokenName) => ...

  // Additional ApolloClient options
  // apollo: { ... }

  // Client local data (see apollo-link-state)
  // clientState: { resolvers: { ... }, defaults: { ... } }
};

// Call this in the Vue app file
export function createProvider(options = {}) {
  const authService = new AuthService();

  const authLink = setContext(async(_, { headers }) => {
    const accessToken = await authService.getAccessToken() || '';  
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${accessToken}`
      }
    }
  })

  // Create apollo client
  const indexesClient = createApolloClient({
    ...defaultOptions,
    link: authLink,
    httpEndpoint: window.$tameoConfig?.indexesApiUrl || "http://localhost:4000/graphql",
    ...options,
  });

  const fundsClient = createApolloClient({
    ...defaultOptions,
    link: authLink,
    httpEndpoint: window.$tameoConfig?.fundsApiUrl || "http://localhost:4000/graphql",
    ...options,
  });

  const kpisClient = createApolloClient({
    ...defaultOptions,
    link: authLink,
    httpEndpoint: window.$tameoConfig?.kpisApiUrl || "http://localhost:4000/graphql",
    ...options,
  });
  //apolloClient.wsClient = wsClient;

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    clients: {
      indexes: indexesClient.apolloClient,
      funds: fundsClient.apolloClient,
      kpis: kpisClient.apolloClient,
    },
    defaultClient: indexesClient.apolloClient,
    defaultOptions: {
      $query: {
        fetchPolicy: 'cache-and-network',
      },
    },
    errorHandler(error) {
      // eslint-disable-next-line no-console
      console.log(
        "%cError",
        "background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;",
        error.message
      );
    },
  });

  return apolloProvider;
}
